import { createFileRoute } from "@tanstack/react-router";
import { Download } from "lucide-react";
import { AdminEmptyTab } from "@/components/dashboard/AdminEmptyTab";

export const Route = createFileRoute("/dashboard/admin/revenue-yearly")({
  head: () => ({ meta: [{ title: "Yearly Revenue · Admin" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <AdminEmptyTab
      title="Yearly revenue"
      description="Annual recurring revenue and yearly plan performance."
      stats={[
        { label: "ARR" },
        { label: "Yearly subscribers" },
        { label: "Avg. contract value" },
        { label: "Renewal rate" },
      ]}
      body="Yearly revenue breakdown will appear here."
      primaryAction={{ label: "Export report", icon: Download }}
      columns={["Year", "ARR", "New", "Renewed", "Churn", "Net"]}
    />
  ),
});
